import { extends as _extends } from '../../_virtual/_rollupPluginBabelHelpers.js';
import React from 'react';
import { _cs } from '@togglecorp/fujs';
import useUiModeClassName from '../../hooks/useUiModeClassName.js';
import { genericMemo } from '../../utils/index.js';
import styles from './styles.css.js';

/**
 * The most basic button component (without styles)
 * This component is meant to be a builder component
 * and comes only with the functionality of button but no
 * styling. Since, `button` element in html has browser and OS dependent styling,
 * we use raw button as a base component for other types of buttons or
 * clickable elements
 */
function RawButton(props) {
  const {
    className,
    onClick,
    uiMode,
    children,
    disabled,
    elementRef,
    name,
    focused,
    ...otherProps
  } = props;
  const handleClick = React.useCallback(e => {
    if (onClick) {
      onClick(name, e);
    }
  }, [onClick, name]);
  const uiModeClassName = useUiModeClassName(uiMode, styles.light, styles.dark);
  return /*#__PURE__*/React.createElement("button", _extends({
    ref: elementRef,
    type: "button",
    className: _cs(styles.rawButton, focused && styles.focused, uiModeClassName, className),
    disabled: disabled,
    onClick: onClick ? handleClick : undefined,
    name: name // eslint-disable-next-line react/jsx-props-no-spreading

  }, otherProps), children);
}

var RawButton$1 = genericMemo(RawButton);

export { RawButton$1 as default };
//# sourceMappingURL=index.js.map
